// Approximate coordinates for Dubai & Abu Dhabi communities + curated tourism POIs.
// Used by the project location map (OpenStreetMap / Leaflet).

export const CITY_CENTER = {
  Dubai: { lat: 25.2048, lng: 55.2708 },
  'Abu Dhabi': { lat: 24.4539, lng: 54.3773 },
};

// area name (normalized) -> { lat, lng, city }
export const AREA_COORDS = {
  'downtown dubai': { lat: 25.1972, lng: 55.2744, city: 'Dubai' },
  downtown: { lat: 25.1972, lng: 55.2744, city: 'Dubai' },
  'business bay': { lat: 25.1850, lng: 55.2650, city: 'Dubai' },
  'dubai marina': { lat: 25.0805, lng: 55.1403, city: 'Dubai' },
  marina: { lat: 25.0805, lng: 55.1403, city: 'Dubai' },
  'palm jumeirah': { lat: 25.1124, lng: 55.1390, city: 'Dubai' },
  'jumeirah village circle': { lat: 25.0590, lng: 55.2060, city: 'Dubai' },
  jvc: { lat: 25.0590, lng: 55.2060, city: 'Dubai' },
  'jumeirah beach residence': { lat: 25.0785, lng: 55.1340, city: 'Dubai' },
  jbr: { lat: 25.0785, lng: 55.1340, city: 'Dubai' },
  'dubai hills estate': { lat: 25.1050, lng: 55.2460, city: 'Dubai' },
  'dubai hills': { lat: 25.1050, lng: 55.2460, city: 'Dubai' },
  'dubai creek harbour': { lat: 25.2030, lng: 55.3530, city: 'Dubai' },
  'creek harbour': { lat: 25.2030, lng: 55.3530, city: 'Dubai' },
  'emaar beachfront': { lat: 25.0950, lng: 55.1470, city: 'Dubai' },
  'dubai islands': { lat: 25.3080, lng: 55.3140, city: 'Dubai' },
  jumeirah: { lat: 25.2048, lng: 55.2430, city: 'Dubai' },
  'al barsha': { lat: 25.1120, lng: 55.2000, city: 'Dubai' },
  'arabian ranches': { lat: 25.0500, lng: 55.2700, city: 'Dubai' },
  'damac hills': { lat: 25.0280, lng: 55.2480, city: 'Dubai' },
  meydan: { lat: 25.1640, lng: 55.3050, city: 'Dubai' },
  'mbr city': { lat: 25.1750, lng: 55.3100, city: 'Dubai' },
  'mohammed bin rashid city': { lat: 25.1750, lng: 55.3100, city: 'Dubai' },
  'district one': { lat: 25.1680, lng: 55.3020, city: 'Dubai' },
  'district 11': { lat: 25.1620, lng: 55.3180, city: 'Dubai' },
  'sobha hartland': { lat: 25.1860, lng: 55.3010, city: 'Dubai' },
  'dubai silicon oasis': { lat: 25.1210, lng: 55.3780, city: 'Dubai' },
  'jumeirah lake towers': { lat: 25.0690, lng: 55.1430, city: 'Dubai' },
  jlt: { lat: 25.0690, lng: 55.1430, city: 'Dubai' },
  'al furjan': { lat: 25.0260, lng: 55.1470, city: 'Dubai' },
  'dubai sports city': { lat: 25.0380, lng: 55.2200, city: 'Dubai' },
  dubailand: { lat: 25.0450, lng: 55.2470, city: 'Dubai' },
  'bluewaters island': { lat: 25.0790, lng: 55.1230, city: 'Dubai' },
  bluewaters: { lat: 25.0790, lng: 55.1230, city: 'Dubai' },
  'city walk': { lat: 25.2080, lng: 55.2630, city: 'Dubai' },
  difc: { lat: 25.2110, lng: 55.2810, city: 'Dubai' },
  'expo city': { lat: 24.9680, lng: 55.1510, city: 'Dubai' },
  'the valley': { lat: 25.0100, lng: 55.4300, city: 'Dubai' },
  'tilal al ghaf': { lat: 25.0100, lng: 55.2750, city: 'Dubai' },
  'rashid yachts & marina': { lat: 25.2560, lng: 55.2770, city: 'Dubai' },
  'mina rashid': { lat: 25.2560, lng: 55.2770, city: 'Dubai' },
  'port de la mer': { lat: 25.2420, lng: 55.2570, city: 'Dubai' },
  'al jaddaf': { lat: 25.2210, lng: 55.3290, city: 'Dubai' },
  'za\'abeel': { lat: 25.2150, lng: 55.2900, city: 'Dubai' },
  'palm jebel ali': { lat: 24.9930, lng: 54.9800, city: 'Dubai' },
  'emaar south': { lat: 24.8790, lng: 55.0160, city: 'Dubai' },
  'dubai design district': { lat: 25.1870, lng: 55.2980, city: 'Dubai' },
  d3: { lat: 25.1870, lng: 55.2980, city: 'Dubai' },
  'al barari': { lat: 25.0970, lng: 55.3030, city: 'Dubai' },
  'the haven': { lat: 25.0970, lng: 55.3030, city: 'Dubai' },
  'jumeirah golf estates': { lat: 25.0410, lng: 55.2010, city: 'Dubai' },
  'jumeirah islands': { lat: 25.0560, lng: 55.1560, city: 'Dubai' },
  'the world islands': { lat: 25.2240, lng: 55.1660, city: 'Dubai' },
  'international city': { lat: 25.1660, lng: 55.4080, city: 'Dubai' },
  'motor city': { lat: 25.0450, lng: 55.2410, city: 'Dubai' },
  'town square': { lat: 25.0010, lng: 55.2540, city: 'Dubai' },
  // Abu Dhabi
  'yas island': { lat: 24.4980, lng: 54.6070, city: 'Abu Dhabi' },
  'saadiyat island': { lat: 24.5450, lng: 54.4350, city: 'Abu Dhabi' },
  saadiyat: { lat: 24.5450, lng: 54.4350, city: 'Abu Dhabi' },
  'al reem island': { lat: 24.4960, lng: 54.4060, city: 'Abu Dhabi' },
  'reem island': { lat: 24.4960, lng: 54.4060, city: 'Abu Dhabi' },
  'al maryah island': { lat: 24.5000, lng: 54.3880, city: 'Abu Dhabi' },
  corniche: { lat: 24.4760, lng: 54.3350, city: 'Abu Dhabi' },
  'al raha beach': { lat: 24.4530, lng: 54.6080, city: 'Abu Dhabi' },
  'masdar city': { lat: 24.4280, lng: 54.6150, city: 'Abu Dhabi' },
  'hudayriyat island': { lat: 24.4190, lng: 54.3000, city: 'Abu Dhabi' },
  'al hudayriat island': { lat: 24.4190, lng: 54.3000, city: 'Abu Dhabi' },
  hudayriat: { lat: 24.4190, lng: 54.3000, city: 'Abu Dhabi' },
  'al jubail island': { lat: 24.5420, lng: 54.5120, city: 'Abu Dhabi' },
  'nurai island': { lat: 24.5880, lng: 54.4660, city: 'Abu Dhabi' },
  'al ghadeer': { lat: 24.3170, lng: 55.0420, city: 'Abu Dhabi' },
  'khalifa city': { lat: 24.4190, lng: 54.5760, city: 'Abu Dhabi' },
  'al reeman': { lat: 24.3350, lng: 54.7280, city: 'Abu Dhabi' },
  'alreeman': { lat: 24.3350, lng: 54.7280, city: 'Abu Dhabi' },
  'zayed city': { lat: 24.3580, lng: 54.5440, city: 'Abu Dhabi' },
  'abu dhabi': { lat: 24.4539, lng: 54.3773, city: 'Abu Dhabi' },
};

// Curated tourism interest points
export const POIS = [
  // Dubai
  { name: 'Burj Khalifa', lat: 25.1972, lng: 55.2744, city: 'Dubai' },
  { name: 'The Dubai Mall', lat: 25.1985, lng: 55.2796, city: 'Dubai' },
  { name: 'Dubai Fountain', lat: 25.1955, lng: 55.2753, city: 'Dubai' },
  { name: 'Museum of the Future', lat: 25.2191, lng: 55.2820, city: 'Dubai' },
  { name: 'Dubai Frame', lat: 25.2353, lng: 55.3003, city: 'Dubai' },
  { name: 'Burj Al Arab', lat: 25.1412, lng: 55.1853, city: 'Dubai' },
  { name: 'Palm Jumeirah · Atlantis', lat: 25.1304, lng: 55.1171, city: 'Dubai' },
  { name: 'Ain Dubai', lat: 25.0790, lng: 55.1190, city: 'Dubai' },
  { name: 'Dubai Marina', lat: 25.0805, lng: 55.1403, city: 'Dubai' },
  { name: 'JBR · The Walk', lat: 25.0785, lng: 55.1340, city: 'Dubai' },
  { name: 'Mall of the Emirates', lat: 25.1181, lng: 55.2003, city: 'Dubai' },
  { name: 'Global Village', lat: 25.0700, lng: 55.3080, city: 'Dubai' },
  { name: 'Dubai Creek Harbour', lat: 25.2030, lng: 55.3530, city: 'Dubai' },
  // Abu Dhabi
  { name: 'Sheikh Zayed Grand Mosque', lat: 24.4128, lng: 54.4748, city: 'Abu Dhabi' },
  { name: 'Louvre Abu Dhabi', lat: 24.5339, lng: 54.3984, city: 'Abu Dhabi' },
  { name: 'Ferrari World', lat: 24.4836, lng: 54.6070, city: 'Abu Dhabi' },
  { name: 'Yas Waterworld', lat: 24.4889, lng: 54.6030, city: 'Abu Dhabi' },
  { name: 'Warner Bros. World', lat: 24.4870, lng: 54.5990, city: 'Abu Dhabi' },
  { name: 'Qasr Al Watan', lat: 24.4617, lng: 54.3050, city: 'Abu Dhabi' },
  { name: 'Emirates Palace', lat: 24.4616, lng: 54.3172, city: 'Abu Dhabi' },
  { name: 'Corniche Beach', lat: 24.4760, lng: 54.3200, city: 'Abu Dhabi' },
];

export function normalizeArea(area) {
  return String(area || '').toLowerCase().trim().replace(/\s+/g, ' ');
}

// Resolve an area name to coordinates; tries exact then longest partial match.
export function areaCoords(area) {
  const key = normalizeArea(area);
  if (!key) return null;
  if (AREA_COORDS[key]) return AREA_COORDS[key];
  // prefer the longest matching key so "jumeirah village circle" doesn't match "jumeirah"
  let best = null;
  for (const k of Object.keys(AREA_COORDS)) {
    if (key.includes(k) || k.includes(key)) {
      if (!best || k.length > best.length) best = k;
    }
  }
  return best ? AREA_COORDS[best] : null;
}
